// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__eaDmB","subheader":"ReorderModal_subheader__ygz2C","listWrap":"ReorderModal_listWrap__2S3pe"};